import logo from 'url:../../asset/logo_light.svg';

export default function Header() {
  return <header className='flex flex-row m-4'>
    <img src={logo} alt="Salt Logo" className="mx-auto w-48" />
    <div className="flex-1" />
    <nav className="flex items-center space-x-4">
      {/* <HeaderButton text="Talk with Us" style='secondary' /> */}
      <HeaderButton text="Church Hub" style='primary' link='https://hub.saltplatform.com' />
    </nav>
  </header>
}

type HeaderButtonStyle = "primary" | "secondary";

function HeaderButton(props: {
  text: string,
  style: HeaderButtonStyle,
  link: string
}) {
  const bg = props.style === "primary" ? "bg-accent" : "bg-gray-300";
  const textColor = props.style === "primary" ? "text-white" : "text-gray-800";

  return <a href={props.link} target="_blank" rel="noopener noreferrer" className={`py-3 px-4 md:py-4 md:px-8 ${bg} ${textColor} text-lg md:text-2xl rounded-full font-medium hover:cursor-pointer hover:opacity-75 transition-opacity duration-300`}>
    {props.text}
    {props.style === "primary" && <span className="ml-2 text-2xl">&rarr;</span>}
  </a>
}